<template>
  <div
    :class="[$style.base, {[$style.smallScreen]: $screen === 's'}, {[$style.mediumScreen]: $screen === 'm'}]"
    v-test="'subscription-pro-only'"
  >
    <BaseText>{{ heading }}</BaseText>
    <div :class="$style.features">
      <div
        v-for="(feature, index) in features"
        :key="index"
        :class="$style.feature"
      >
        <Flex
          direction="column"
          :gap="1.5"
          padding
        >
          <Flex
            direction="column"
            align="center"
            :gap=".5"
          >
            <BaseIcon
              :name="feature.icon"
              size="l"
            />
            <BaseText
              bold
              center
            >
              {{ feature.title }}
            </BaseText>
          </Flex>
          <Flex
            direction="column"
            :gap=".5"
          >
            <Flex
              align="center"
              :gap=".5"
              v-for="(featureItem, index) in feature.features"
              :key="index"
            >
              <BaseIcon
                name="check"
                color="success"
                size="l"
              />
              <BaseText>{{ featureItem }}</BaseText>
            </Flex>
          </Flex>
        </Flex>
        <div :class="$style.visualContainer">
          <img :src="feature.visual">
        </div>
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import type { IconName } from '@/components/base-icon/types';

defineProps<{
  heading: string;
  features: {
    icon: IconName;
    title: string;
    features: string[];
    visual: string;
  }[];
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}

.features {
  display: flex;
  gap: $spacing;
  align-items: stretch;

  .base.smallScreen &, .base.mediumScreen & {
    flex-direction: column;
  }
}

.feature {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: $radius;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg);

  .base:not(.smallScreen):not(.mediumScreen) & {
    width: 33.333%;
  }
}

.visualContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing * 2;
}
</style>
